import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HistoryRoutingModule } from './history-routing.module';
import { HistoryComponent } from './history.component';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule, DxScrollViewModule, DxChartModule, DxDateBoxModule, DxRangeSelectorModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';


@NgModule({
  declarations: [HistoryComponent],
  imports: [
    CommonModule,
    HistoryRoutingModule,
    DxDataGridModule,
    DevEpressCommonModule,
    DxTextAreaModule,
    DxPopupModule,DxScrollViewModule,DxChartModule,FormsModule,ReactiveFormsModule,DxRangeSelectorModule,DxDateBoxModule,
	DxTableControllerDirective,
  ]
})
export class HistoryModule { }

